<template>
    <div
      class="banner"
      v-if="isCarousel"
    >
    <!-- :height="type=='home'?'750px':'500px'" -->
      <el-carousel :height="type=='detail'?'500px':'750px'" ref="carousel" :interval="5000" arrow="always">
        
        <template>
          <el-carousel-item v-for="(item,index) in carouselList" :key="index">
            <img :src="`https://guanwang-1429605986.cos.ap-guangzhou.myqcloud.com/static/img/${item.imgUrl}`" alt=""/>
             <div class="carousel_title" :class="{
              'alcenter':textAlign!='left'
             }" :style="pageOrg=='details'?'width: 26%;':''" >
              <div class="carousel_title_top" :class="textAlign=='left'?'text_align_left':'text_align_center'">
                <span class="carousel_title_01" :style="pageOrg=='details'?'white-space: break-spaces;font-size: 40px;':''" v-html="item.mainTitle"></span>
                <!-- <span class="carousel_title_02">{{item.subTitle}}</span> -->
              </div>
              <div>
                <span class="carousel_titleTwo">{{item.subTitle}}</span>
              </div>
              <div class="carousel_title_con" :class="{
                'text_align_left':textAlign=='left',
                'text_align_center':textAlign=='center',
                'mBt50':!showBtnC||pageOrg=='aboutUs'||pageOrg=='service',
                'fontSize20':pageOrg=='details'
              }" v-html="item.dec">
              </div>
              <div class="carousel_BtnBox" v-if="showBtnC&&item.btnData.length>0" :style="textAlign=='left'?'':'text-align: center;'">
                <el-button type="primary" size="medium" @click="dialogVisible=true" v-for="(btn,indexb) in item.btnData" :key="indexb" :plain="indexb%2==1?true:false">{{btn.title}}<i class="el-icon-right" style="margin-left: 10px;"></i></el-button>
              </div>
             </div>
          </el-carousel-item>
        </template>
      </el-carousel>
      <el-dialog
        class="dialogBox"
        :visible.sync="dialogVisible"
        width="30%"
        :modal='false'
        @close="dialogVisible=false">
        <template slot="title">
            <span style="display: inline-flex; align-items: center;">
            <img src="https://guanwang-1429605986.cos.ap-guangzhou.myqcloud.com/static/img/phone.png" alt="" style="width: 25px;margin-right: 10px;"/>
            <span style="font-size: 20px;color: rgba(0, 0, 0, 0.40);">联系电话</span>
            </span>
            <el-divider></el-divider>
        </template>

        <span style="font-size: 40px;font-weight: 600;color:rgba(0, 0, 0, 0.90)">0871-63196719</span>
      </el-dialog>
    </div>
    <div class="banner" v-else>
      <img :src="'https://guanwang-1429605986.cos.ap-guangzhou.myqcloud.com/static/img/'+defaultImg" alt="" />
    </div>
    
</template>
<script>
export default {
    name: "banner",
    components: {},
    props:{
      type:String,
      textAlign:String,
      pageOrg:String,
      defaultImg:{ type: String, default: "back_home.webp" },
      carouselList:Array,
      showBtnC:{ type: Boolean, default: false }
    },
    data() {
      return {
        dialogVisible:false,
        bannerList:[],
        isCarousel:true,
        showAnimation:false
      }
    },
    created() {
    },
      
    methods: {
      
      prev() {
          this.$refs.carousel.prev();
      },
      // 下一张轮播
      next() {
          this.$refs.carousel.next();
      },
    }
}
</script>
<style scoped lang="less">
 .mBt50{
  margin-bottom:50px !important;
 }
.banner {
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .left,
    .right {
      transition: all 1s;
      position: absolute;
      z-index: 10;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      img {
        width: 60px;
        height: 60px;
        cursor: pointer;
      }
    }
    .left {
      left: 80px;
    }
    .right {
      right: 80px;
    }
    
  }
 /deep/ .dialogBox {
  // top:20%;
  .el-divider--horizontal{
    margin-bottom: 0;
  }
  .el-dialog__body{
    text-align: center;
  }
}
  .fontSize20{
    font-size: 20px
  } 
  .alcenter{
    width: 100% !important;
    left: 0 !important;
    animation-duration: 0.5s;
    animation-delay: 1s;
    animation-name: fadeInUp;
  }
</style>
<style lang="less">
.carousel_titleTwo{
    margin-top: 20px;
    color: #FFFFFF;
    font-size:20px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/carouselImageNew.vue